import { render, staticRenderFns } from "./MaterialLabelPrintEdit.vue?vue&type=template&id=3089700b&scoped=true&"
import script from "./MaterialLabelPrintEdit.vue?vue&type=script&lang=js&"
export * from "./MaterialLabelPrintEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3089700b",
  null
  
)

export default component.exports